export const FREQS = ["Second", "Minute", "Hour", "Day", "Week", "Month"];

export const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

export const TIMEZONES = [
    { label: "(UTC) Coordinated Universal Time", value: "UTC" },
    { label: "(UTC+01:00) Amsterdam, Berlin, Rome, Paris", value: "W. Europe Standard Time" },
    { label: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi", value: "India Standard Time" },
    { label: "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi", value: "China Standard Time" },
    { label: "(UTC+10:00) Canberra, Melbourne, Sydney", value: "AUS Eastern Standard Time" },
    { label: "(UTC-05:00) Eastern Time (US & Canada)", value: "Eastern Standard Time" },
    { label: "(UTC-08:00) Pacific Time (US & Canada)", value: "Pacific Standard Time" },
];

// Interval validation limits based on frequency
export const INTERVAL_LIMITS = {
	Second: 9999999,
	Minute: 72000,
	Hour: 12000,
	Day: 500,
	Week: 71,
	Month: 16
};

export const ensureSchedule = (rec) => ({ ...rec, schedule: rec.schedule || { weekDays: [], hours: [], minutes: [] } });

export const parseNumberList = (str, min, max) =>
    (str || "")
        .split(/[;,:\s]+/)
        .map((s) => s.trim())
        .filter(Boolean)
        .map(Number)
        .filter((n) => Number.isInteger(n) && n >= min && n <= max)
        .filter((n, i, arr) => arr.indexOf(n) === i)
        .sort((a, b) => a - b);

export const toHHMM = (h, m) => `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;

export const combineTimes = (hours, minutes) => {
    if (!hours?.length && !minutes?.length) return [];
    const hs = hours?.length ? hours : [0];
    const ms = minutes?.length ? minutes : [0];
    const out = [];
    for (const h of hs) for (const m of ms) out.push({ h, m, key: h * 60 + m });
    out.sort((a, b) => a.key - b.key);
    return out.map((t) => toHHMM(t.h, t.m));
};

// format local "YYYY-MM-DDTHH:MM" for datetime-local
export function fmtLocalInput(d) {
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export const findInvalidNumbers = (str, min, max) => {
    if (!str) return [];
    return str
        .split(/[;,:\s]+|,+/)
        .map((s) => s.trim())
        .filter(Boolean)
        .filter((s) => {
            if (!/^\d+$/.test(s)) return true;
            const n = Number(s);
            return !(Number.isInteger(n) && n >= min && n <= max);
        });
}